document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.getElementById('MobileMenu');
  const closeMenu = document.querySelector('[data-mobile-menu-close]');

  const setMenu = (open) => {
    if (!menu || !mobileMenu) return;
    menu.setAttribute('aria-expanded', String(open));
    mobileMenu.hidden = !open;
    document.documentElement.classList.toggle('menu-open', open);
  };

  menu?.addEventListener('click', () => setMenu(mobileMenu.hidden));
  closeMenu?.addEventListener('click', () => setMenu(false));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileMenu && !mobileMenu.hidden) setMenu(false);
  });

  document.querySelectorAll('[data-carousel-direction]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.getElementById(button.dataset.carouselTarget);
      if (!target) return;
      const distance = Math.max(target.clientWidth * 0.78, 240);
      target.scrollBy({ left: Number(button.dataset.carouselDirection) * distance, behavior: 'smooth' });
    });
  });

  const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const updateCartCount = async () => {
    try {
      const response = await fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('.cart-count').forEach((count) => {
        count.textContent = cart.item_count;
      });
      document.querySelectorAll('[aria-label^="Cart,"]').forEach((link) => {
        link.setAttribute('aria-label', `Cart, ${cart.item_count} items`);
      });
    } catch (error) {
      // Cart feedback is optional. The add request already succeeded if this fails.
    }
  };

  document.querySelectorAll('[data-product-root]').forEach((productRoot) => {
    const form = productRoot.querySelector('[data-product-form]');
    if (!form) return;

    const variantDataElement = productRoot.parentElement?.querySelector('[data-product-variants]') || document.querySelector('[data-product-variants]');
    let variants = [];
    try {
      variants = JSON.parse(variantDataElement?.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const optionSelects = [...form.querySelectorAll('[data-option-select]')];
    const variantIdInput = form.querySelector('[data-variant-id]');
    const priceElement = productRoot.querySelector('[data-product-price]');
    const compareElement = productRoot.querySelector('[data-product-compare]');
    const skuElement = productRoot.querySelector('[data-product-sku]');
    const submitButton = form.querySelector('[data-add-to-cart]');
    const submitLabel = form.querySelector('[data-add-to-cart-label]');
    const message = form.querySelector('[data-product-message]');
    const messageText = form.querySelector('[data-product-message-text]');
    const quantityInput = form.querySelector('[data-quantity-input]');
    const galleryStage = productRoot.querySelector('[data-gallery-stage]');
    let currentVariant = variants.find((variant) => String(variant.id) === String(variantIdInput?.value)) || variants[0];

    const setMessage = (text, state) => {
      if (!message || !messageText) return;
      message.hidden = false;
      message.dataset.state = state || 'success';
      messageText.textContent = text;
    };

    const clearMessage = () => {
      if (!message) return;
      message.hidden = true;
      message.dataset.state = '';
    };

    const updateGallery = (variant) => {
      const mediaId = String(variant?.mediaId || '');
      if (!galleryStage || !mediaId) return;
      const target = [...galleryStage.querySelectorAll('[data-media-id]')].find((item) => String(item.dataset.mediaId) === mediaId);
      if (!target) return;
      galleryStage.querySelectorAll('[data-media-id]').forEach((item) => item.classList.toggle('is-active', item === target));
      target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      productRoot.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
        const active = String(thumb.dataset.mediaId) === mediaId;
        thumb.classList.toggle('is-active', active);
        if (active) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    };

    const updateSwatches = () => {
      const activeValue = optionSelects[0]?.value;
      productRoot.querySelectorAll('[data-color-value]').forEach((swatch) => {
        const active = swatch.dataset.colorValue === activeValue;
        swatch.classList.toggle('is-active', active);
        if (active) swatch.setAttribute('aria-current', 'true');
        else swatch.removeAttribute('aria-current');
      });
    };

    const findVariant = () => {
      if (!variants.length) return null;
      const choices = optionSelects.map((select) => select.value);
      let match = variants.find((variant) => variant.options && variant.options.every((value, index) => value === choices[index]));
      if (match) return match;
      match = variants.find((variant) => variant.options && variant.options[0] === choices[0]);
      return match || variants[0];
    };

    const syncVariant = (variant, updateUrl = true) => {
      if (!variant) return;
      currentVariant = variant;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceElement) priceElement.textContent = variant.priceText || '';
      if (compareElement) {
        compareElement.textContent = variant.compareAtPriceText || '';
        compareElement.classList.toggle('is-hidden', !variant.compareAtPriceText);
      }
      if (skuElement) skuElement.textContent = variant.sku || '';
      if (submitButton) submitButton.disabled = !variant.available;
      if (submitLabel) submitLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      updateSwatches();
      updateGallery(variant);
      clearMessage();
      if (updateUrl && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      }
    };

    optionSelects.forEach((select) => {
      select.addEventListener('change', () => {
        const match = findVariant();
        if (!match) return;
        match.options?.forEach((value, index) => {
          if (optionSelects[index] && optionSelects[index].value !== value) optionSelects[index].value = value;
        });
        syncVariant(match);
      });
    });

    productRoot.querySelectorAll('[data-color-value]').forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const primarySelect = optionSelects[0];
        if (!primarySelect) return;
        primarySelect.value = swatch.dataset.colorValue;
        primarySelect.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    productRoot.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const target = [...(galleryStage?.querySelectorAll('[data-media-id]') || [])].find((item) => String(item.dataset.mediaId) === String(thumb.dataset.mediaId));
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        productRoot.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
          const active = item === thumb;
          item.classList.toggle('is-active', active);
          if (active) item.setAttribute('aria-current', 'true');
          else item.removeAttribute('aria-current');
        });
      });
    });

    form.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!quantityInput) return;
        const current = Number.parseInt(quantityInput.value, 10) || 1;
        const next = Math.max(1, current + Number(button.dataset.quantityChange || 0));
        quantityInput.value = next;
        clearMessage();
      });
    });

    quantityInput?.addEventListener('change', () => {
      quantityInput.value = Math.max(1, Number.parseInt(quantityInput.value, 10) || 1);
    });

    form.addEventListener('submit', async (event) => {
      if (!window.fetch || !currentVariant || !currentVariant.available) return;
      event.preventDefault();
      clearMessage();
      submitButton?.setAttribute('disabled', 'disabled');
      if (submitLabel) submitLabel.textContent = 'Adding...';
      try {
        const response = await fetch(`${rootPath}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item.');
        await updateCartCount();
        setMessage('Added to cart.', 'success');
        if (submitLabel) submitLabel.textContent = 'Added';
        window.setTimeout(() => {
          if (submitLabel) submitLabel.textContent = currentVariant.available ? 'Add to cart' : 'Sold out';
        }, 1800);
      } catch (error) {
        setMessage(error.message || 'Unable to add this item.', 'error');
        if (submitLabel) submitLabel.textContent = currentVariant.available ? 'Add to cart' : 'Sold out';
      } finally {
        if (submitButton) submitButton.disabled = !currentVariant.available;
      }
    });

    const zipInput = productRoot.querySelector('[data-zip-input]');
    const zipUpdate = productRoot.querySelector('[data-zip-update]');
    const shippingMessage = productRoot.querySelector('[data-shipping-message]');
    zipUpdate?.addEventListener('click', () => {
      const zip = zipInput?.value.trim();
      if (!shippingMessage) return;
      shippingMessage.textContent = zip
        ? `Shipping options for ${zip} will be confirmed at checkout.`
        : 'Enter a ZIP or Postal Code to check shipping options.';
    });

    syncVariant(currentVariant, false);
  });
});
